export function galleryUrl(publicId, cloudName) {
  return `https://res.cloudinary.com/${cloudName}/image/upload/f_auto,q_auto,c_fill,ar_4:3,w_1200/${publicId}`;
}

export function loadUploadWidget() {
  return new Promise((resolve, reject) => {
    if (window.cloudinary && window.cloudinary.createUploadWidget) return resolve(window.cloudinary);
    const existing = document.getElementById("cloudinary-widget-script");
    if (existing) {
      existing.addEventListener("load", () => resolve(window.cloudinary));
      return;
    }
    const s = document.createElement("script");
    s.id = "cloudinary-widget-script";
    s.src = "https://upload-widget.cloudinary.com/global/all.js";
    s.async = true;
    s.onload = () => resolve(window.cloudinary);
    s.onerror = reject;
    document.body.appendChild(s);
  });
}
